var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import CarCrashOutlinedIcon from "@mui/icons-material/CarCrashOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import { Box, Card, CardContent, Chip } from "@mui/material";
import { useAuth } from "../../hooks/useAuth";
import { obterDadosCondutor } from "../../services/habilitacao.service";
import { CategoryEnum } from '../../types/categorias.type';
import { Loading } from "../Loading";
import { SnackbarFeedback } from "../SnackbarFeedback";
import { CardServico } from "./CardServico";
import { Progress } from "../Habilitacao/Progress";
export var CategorySection = function (_a) {
    var category = _a.category;
    var userInfo = useAuth().userInfo;
    var _b = useState(), data = _b[0], setData = _b[1];
    var _c = useState(_jsx(BadgeOutlinedIcon, {})), icon = _c[0], setIcon = _c[1];
    var _d = useState(false), isProcessOpen = _d[0], setIsProcessOpen = _d[1];
    var _e = useState(), erro = _e[0], setErro = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    useEffect(function () {
        switch (category.title) {
            case CategoryEnum.HABILITACAO:
                setIcon(_jsx(BadgeOutlinedIcon, {}));
                break;
            case CategoryEnum.VEICULOS:
                setIcon(_jsx(DirectionsCarFilledOutlinedIcon, {}));
                break;
            case CategoryEnum.INFRACOES:
                setIcon(_jsx(CarCrashOutlinedIcon, {}));
                break;
            default:
                setIcon(_jsx(BadgeOutlinedIcon, {}));
                break;
        }
    }, [category.title]);
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _d.sent();
                        setData(response);
                        setIsProcessOpen(response.processoaberto === 'True');
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _d.sent();
                        setErro((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao buscar dados do condutor");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) && fetchDados();
    }, [data === null || data === void 0 ? void 0 : data.numeroRenach, userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    var isServiceAvalaible = function (service) {
        switch (service.title) {
            case 'Solicitar Renovação de CNH':
                if ((data === null || data === void 0 ? void 0 : data.processoRenovacao) === 'N')
                    return false;
                return true;
            case 'Solicitar troca da CNH temporária para CNH definitiva':
                if ((data === null || data === void 0 ? void 0 : data.processoDefinitiva) === 'N')
                    return false;
                return true;
            case 'Solicitar Segunda Via da CNH':
                if ((data === null || data === void 0 ? void 0 : data.processoSegundaVia) === 'N')
                    return false;
                return true;
            case 'Solicitar Abertura do Processo PID (Carteira Internacional)':
                if ((data === null || data === void 0 ? void 0 : data.processoPid) === 'N')
                    return false;
                return true;
            default:
                return true;
        }
    };
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "center", mt: "-9rem" }, { children: [category.title === 'Habilitação' && (data === null || data === void 0 ? void 0 : data.processoaberto) === 'True' && (_jsx(Box, __assign({ sx: { width: { md: "70%", xs: "90%" } } }, { children: _jsx(Progress, {}) }))), _jsx(Card, __assign({ sx: { width: { md: "60%", xs: "90%" } } }, { children: _jsx(CardContent, __assign({ sx: { paddingX: 0, backgroundColor: "#f8f8f8" } }, { children: _jsx(Box, __assign({ mt: "0.75rem", display: "flex", gap: "0.25rem", flexWrap: "wrap" }, { children: category.tags.map(function (tag, index) { return (_jsx(Chip, { label: tag, sx: { borderRadius: "0.25rem", backgroundColor: "#EAEFF9" } }, index)); }) })) })) })), _jsx(Box, __assign({ display: "flex", width: { md: "60%", xs: "90%" }, flexWrap: "wrap", justifyContent: { md: "start", xs: "center" }, gap: "1rem" }, { children: category.services.map(function (service, index) { return (isServiceAvalaible(service) && !(!isProcessOpen && service.title === 'Processo em aberto') && (_jsx(CardServico, { icone: icon, titulo: service.title, descricao: service.subtitle, irPara: service.goTo }, index))); }) })), erro && (_jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" }))] })));
};
